// extracted by mini-css-extract-plugin
export var compactFilters = "_eo-4";
export var detailImage = "_eo-1";
export var dropdownContainer = "_eo-2";
export var imageContainer = "_eo-0";
export var selectedCard = "_eo-3";